import onServiceRequest from '../actions/onServiceRequest';
import onServiceResponse from '../actions/onServiceResponse';
import onSuggestionsProcessed from '../actions/onSuggestionsProcessed';
import getScenarioStore from '../store/getScenarioStore';
import { mutator } from 'satcheljs';

mutator(onServiceResponse, actionMessage => {
    const { scenarioId, traceId, isQFTraceId } = actionMessage;
    const store = getScenarioStore(scenarioId);

    store.latestTraceId = traceId;

    if (isQFTraceId) {
        store.latestQFTraceId = traceId;
    }
});

mutator(onServiceRequest, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).latestQFRequestId = actionMessage.requestId;
});

mutator(onSuggestionsProcessed, actionMessage => {
    if (actionMessage.suggestionSet.Suggestions.length > 0) {
        getScenarioStore(actionMessage.scenarioId).latestRenderedQFTraceId =
            actionMessage.suggestionSet.TraceId;
    }
});
